import { useCallback, useState } from 'react';
import {
  Query,
  useActiveAccountContext,
  ExistentAccountChannelRequest,
  accountPath,
} from '@/true-fsd/data/advertiser-account';
import {
  AwaitNewChannelForm,
  AwaitNewChannelFormProps,
} from './shared/AwaitNewChannelForm';
import { PollNewChannel, type PollNewChannelProps } from './PollNewChannel';

export type AddChannelToAccountProps = {
  RenderPollLayout: PollNewChannelProps['RenderLayout'];
  RenderAwaitLayout: AwaitNewChannelFormProps['RenderLayout'];
  RenderAwaitBack: AwaitNewChannelFormProps['RenderBack'];
} & Pick<PollNewChannelProps, 'onChannel' | 'onContinue'>;

export const AddChannelToAccount = ({
  RenderPollLayout,
  RenderAwaitLayout,
  RenderAwaitBack,
  onChannel,
}: AddChannelToAccountProps) => {
  const [channelRequest, setChannelRequest] =
    useState<ExistentAccountChannelRequest | null>(null);

  const onCancel = useCallback(() => setChannelRequest(null), []);

  const { activeAccount } = useActiveAccountContext();

  const { mutateAsync } = Query.usePutChannelRequest(activeAccount);

  const mutateAsyncChannel: AwaitNewChannelFormProps['mutateAsync'] =
    useCallback(
      ({ channel, onError }) =>
        mutateAsync(
          { channel },
          {
            onError,
            onSuccess(data) {
              setChannelRequest(data);
            },
          },
        ),
      [mutateAsync],
    );

  const onContinue: NonNullable<PollNewChannelProps['onContinue']> =
    useCallback(
      (navigate) => {
        void navigate(accountPath(activeAccount));
      },
      [activeAccount],
    );

  if (channelRequest) {
    return (
      <PollNewChannel
        channelRequest={channelRequest}
        RenderLayout={RenderPollLayout}
        onChannel={onChannel}
        onCancel={onCancel}
        onContinue={onContinue}
      />
    );
  }
  return (
    <AwaitNewChannelForm
      mutateAsync={mutateAsyncChannel}
      RenderLayout={RenderAwaitLayout}
      RenderBack={RenderAwaitBack}
    />
  );
};
